import type { FaireProductEntity } from "../../entity_types/product";

export const atc_updated_moma_9: FaireProductEntity = {
  token: "atc_updated_moma_9",
  type: "product",
  name: "Amber Glass Tea Set",
  brandName: "MoMA Design Store",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/c595f3dee0f9c06f47b751e8e75a9008eb8d70872bf1fb07d1d8a29df87c29fe.webp",
  priceDollars: 38,
  msrpDollars: 46,
  description: "Teapot with matching teacups.",
  tags: ["home", "design"],
  freeShipping: true,
  meta: {
    source: "mock",
    importedAt: "2026-03-25T00:00:00.000Z",
    importedBy: "atc-entity-migration",
  },
};
